export const Config = {
  url: "/img/logo/logo-_THEME_NAME_.svg"
};

export default Config;
